<div
    class="agpr-masterLayout ui-feature u-lgPadding"
    [ngClass]="{
        'agpr-masterLayout--horizontal': layout === layoutTypes.horizontal,
        'agpr-masterLayout--vertical': layout === layoutTypes.vertical,
        'agpr-masterLayout--fullWidth': allowFullWidth
    }"
>
    <ng-container>
        <div class="agpr-masterLayout-navigation">
            <ng-container *ngTemplateOutlet="navigationTemplate"></ng-container>
        </div>
        <div [id]="id + '-content'" class="agpr-masterLayout-outlet">
            <router-outlet></router-outlet>
        </div>
    </ng-container>
</div>
